import { advancedFlowSchema_ } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import {
  AutomationChannel,
  AutomationSortKey,
  AutomationStatus,
} from "@redotech/redo-model/advanced-flow/common";
import { categories } from "@redotech/redo-model/advanced-flow/triggers";
import { SortDirection } from "@redotech/redo-model/tables/table";
import * as z from "zod/v4";

export const UserInfo = z.object({
  _id: z.string(),
  name: z.string().nullish(),
  email: z.string().nullish(),
});

export type UserInfo = z.infer<typeof UserInfo>;

export const getAdvancedFlows = {
  name: "getAdvancedFlows" as const,
  input: z.object({
    getUsers: z.boolean(),
    includeMetrics: z.boolean(),
    includeOriginFlows: z.boolean(),
    searchString: z.string().optional(),
    filters: z
      .object({
        status: z.array(z.enum(AutomationStatus)).optional(),
        channel: z.array(z.enum(AutomationChannel)).optional(),
        category: z.array(z.enum(categories)).optional(),
      })
      .optional(),
    sort: z
      .object({
        key: z.enum(AutomationSortKey),
        direction: z.enum(SortDirection),
      })
      .optional(),
    page: z.optional(z.number().positive().int()),
    pageSize: z.optional(z.number().positive().int()),
  }),
  output: z.object({
    advancedFlows: z.array(
      advancedFlowSchema_.extend({
        metrics: z.any(),
        isOrigin: z.boolean().optional(),
        canRevert: z.boolean().optional(),
      }),
    ),
    failedToParseFlows: z.array(
      z.object({ _id: z.string(), name: z.string().nullish() }),
    ),
    users: z.map(z.string(), UserInfo).nullish(),
    totalCount: z.number().int(),
  }),
};
